module.exports = __webpack_public_path__ + "img/6bb6477.gif";